export default {
	props: {
		isPlaceholder: Boolean,
		event: Object,
		trackingStartDate: {
			// needed on the tracked items page
			type: String,
			required: false,
		},
		trackingEndDate: {
			// needed on the tracked items page
			type: String,
			required: false,
		},
	},

	methods: { handleTrashEventItemClick },

	computed: { trashEventImage },
};

function trashEventImage() {
	return this.$utils.getImageFromImageId(this.event.image_id, {
		resize: {
			height: 100,
			fit: "cover",
		},
	});
}

function handleTrashEventItemClick() {
	const request = { label_id: this.event.label_id };

	if (this.trackingStartDate) request.tracking_start_date = this.trackingStartDate;

	if (this.trackingEndDate) request.tracking_end_date = this.trackingEndDate;

	this.$eventBus.$emit("loadItemTrashEvents", request);
}
